module.exports = __webpack_public_path__ + "static/img/img_form1_ko.86a81e89.png";